<template>
    <v-container>
        <v-row>
            <v-col class="col-container mr-1 mb-2">
                <p class="mb-1">{{ this.$f.tc('description') }}</p>
                <textarea
                    v-model="func.full_desc"
                    class="fci-scrollbar mb-2"
                    style="background-color: #e9ecef;"
                    :readonly="true"
                ></textarea>
                <span>{{ this.$f.tc('input') }}</span>
                <div class="col-12 mb-3 pt-1">
                    <div class="input-display mb-2" v-if="inputChips.length > 0" >
                        <div class="input-chip" v-for="(i, idx) of inputChips" :key="idx">
                            <span>{{ i }}</span>
                        </div>
                    </div>
                    <div class="input-display mb-2" v-else>
                        <div class="input-chip" style="background-color: darkorange !important;">
                            <span>{{ this.$f.tc('noAgrs') }}</span>
                        </div>
                    </div>
                </div>
                <p class="mb-1">{{ this.$f.tc('functionLua') }}</p>
                <div class="editor-wrapper mb-2">
                    <textarea v-model="func.script" ref="textarea1" :readonly="true"></textarea>
                </div>
            </v-col>
            <v-col  class="col-container ml-1 mb-2">
                <p class="mb-1">{{ this.$f.tc('testFunction') }}</p>
                <div class="editor-wrapper mb-2">
                    <textarea ref="textarea2" ></textarea>
                </div>
                <v-btn class="mb-2" color="primary" @click="executeFunction">{{ $f.tc('execute') }}</v-btn>
                <textarea
                    id="testResult"
                    v-model="testResult"
                    class="fci-scrollbar"
                    style="background-color: #e9ecef;"
                    :readonly="true"
                ></textarea>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import moment from 'moment'
import { BotService } from '@/services/bot.service'
import AppService from '@/services/app.service'

export default {
    name: 'FunctionItem',
    props: {
        func: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            inputChips: [],
            editor: null,
            testScript: null,
            testResult: null
        }
    },
    mounted () {
        this.inputChips = this.func.input ? this.func.input : []
        setTimeout(() => {
            let textarea1 = this.$refs.textarea1
            this.editor = window.CodeMirror.fromTextArea(textarea1, {
                styleActiveLine: true,
                matchBrackets: true,
                theme: 'default',
                lineNumbers: true,
                mode: 'lua',
                readOnly: true,
                value: this.func.script
            })
        }, 200)
        setTimeout(() => {
            let textarea2 = this.$refs.textarea2
            this.testScript = window.CodeMirror.fromTextArea(textarea2, {
                styleActiveLine: true,
                matchBrackets: true,
                theme: 'default',
                lineNumbers: true,
                mode: 'lua'
            })
        }, 200)
    },
    methods: {
        displayTime (value, format) {
            if (!format) {
                format = 'YYYY-MM-DD HH:mm:ss'
            }
            try {
                let ct = moment.utc(value).local()
                return ct.format(format)
            } catch (e) {
                return value
            }
        },
        expandDetailFunction (func) {
            if (func.show_detail === true) {
                func.show_detail = false
                setTimeout(function () { func.load_detail = false }, 500)
            } else {
                func.show_detail = true
                func.load_detail = true
            }
            // close other function
            // for (let i = 0; i < this.lst_lua_function_builtin.length; i++) {
            //     if (this.lst_lua_function_builtin[i].id !== func.id) {
            //         this.lst_lua_function_builtin[i].show_detail = false
            //         this.lst_lua_function_builtin[i].load_detail = false
            //     }
            // }
        },
        async executeFunction () {
            let script = this.testScript.getValue()
            let testResult = await BotService.testLuaFunction(this.$route.params.botCode, script, this.func)
            if (testResult === 'noScript') {
                AppService.toastError(this.$f.tc('nothingToExecute'))
            } else {
                this.testResult = testResult
            }
        }
    }
}
</script>
<style>
.col-container {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
}
textarea {
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 120px;
    min-height: 100px;
    max-height: 500px;
}
#testResult{
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 150px !important;
    min-height: 100px;
    max-height: 500px;
}
.input-display .input-chip {
  float: left;
  padding: 2px 8px;
  background-color: #0062cc;
  margin-right: 5px;
  color: #FFF;
  font-size: 13px;
  border-radius: 20px;

}
.editor-wrapper {
    max-width: 520px;
    border: 1px solid #ccc;
}
</style>
